<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_FSD">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ this.getLanguage["DLSR"]["MGBT"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeFSD">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div>
                                        <CCol>
                                            <div class="custom-table-wrapper">
                                                <div class="pageBtn table-header">
                                                    <button @click="ctrPageGBT(+int_Page_GBT - 1)">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page_GBT"
                                                           type="number"
                                                           v-shortkey.avoid
                                                           @keyup="ctrPageGBT(+int_Page_GBT,0)" />
                                                    <span class="tableItemCount">/ {{int_TP_GBT}}</span>
                                                    <button @click="ctrPageGBT(+int_Page_GBT + 1)">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                                <table class="custom-table afb-blue custom-table-inPopUp">
                                                    <thead>
                                                        <tr>
                                                            <th colspan="100%">{{this.getLanguage['MTA']['FSS']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <td colspan="100%" v-if="gbtData == null || gbtData.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                        <tr v-else class='kema-eft'>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>{{this.getLanguage['MTA']['TSW']}}</td>
                                                            <td :style="renderActivityStyle(1)" :class="gbtData.FSWA >= 0 ? 'positive-number' : ''" class="tableCtnRight">{{ formatNumber(gbtData.FSWA, 2,gbtData.CS) }}</td>
                                                        </tr>
                                                    </tbody>
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 5%;">{{ this.getLanguage["GL"]["NO"] }}</th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['PM']['GPROV']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['BI']}}
                                                            </th>

                                                            <th style="width: 20%;">
                                                                {{this.getLanguage['BETRPT']['G']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['BA']}}
                                                            </th>
                                                            <th style="width: 15%;">
                                                                {{this.getLanguage['BETRPT']['BT']}}
                                                            </th>
                                                            <th style="width: 5%;">
                                                                {{this.getLanguage['MEM']['CI']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['MEM']['TO']}}
                                                            </th>
                                                            <th style="width: 10%;">
                                                                {{this.getLanguage['BETRPT']['WL']}}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_trans == null || obj_trans.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_trans">
                                                        <td>{{ CountItemGbt(index+1) }}</td>
                                                        <td>{{ renderProviderName(data.PN) }}</td>
                                                        <td>{{ data.TI }}</td>

                                                        <td>{{ renderGameName(data.PN, data.GN) }}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.BA, 2, data.ISOC, false) }}</td>
                                                        <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</td>
                                                        <td>{{ data.ISOC }}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.TA, 2, data.ISOC, false) }}</td>
                                                        <td :class="data.WLA > 0? 'positive-number' : ''" class="tableCtnRight">{{formatNumber(data.WLA, 2,"")}}</td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </CCol>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'RS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['RS']}}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GN' && !hideBrand">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MTA']['BN']}}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TSID'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                <span style="color:#ff8c00;font-weight:700">{{getLanguage['MEM']['TSID']}}</span> /
                                                <span style="color:red;font-weight:900">{{getLanguage['MEM']['SU']}}</span>
                                            </template>
                                            <template v-else-if="header == 'PC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MTA']['PMT']}}
                                                <i @click="setSortTable('PC')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['PA']}}
                                                <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'RA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['FBA']}}
                                                <i @click="setSortTable('RA')" :class="setSortLogo('RA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'WBB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['BB']}}
                                                <i @click="setSortTable('WBB')" :class="setSortLogo('WBB')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ATA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['TO']}}
                                                <i @click="setSortTable('ATA')" :class="setSortLogo('ATA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'FS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DLSP']['NOS']}}
                                                <i @click="setSortTable('FS')" :class="setSortLogo('FS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'FSWA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['DLSP']['SW']}}
                                                <i @click="setSortTable('FSWA')" :class="setSortLogo('FSWA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PWL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['PMWL']}}
                                                <i @click="setSortTable('PWL')" :class="setSortLogo('PWL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['CT']}}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['OP']}}
                                                <i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ATS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['APPTS']}}
                                                <i @click="setSortTable('ATS')" :class="setSortLogo('ATS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CLOTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['CPLTIME']}}
                                                <i @click="setSortTable('CLOTS')" :class="setSortLogo('CLOTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PTTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['PTTS']}}
                                                <i @click="setSortTable('PTTS')" :class="setSortLogo('PTTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AIP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['IP']}}
                                                <i @click="setSortTable('AIP')" :class="setSortLogo('AIP')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('PR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['PR']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="searchExcludeSubAgent" id="searchExcludeSubAgent" />
                                        <label class="searchLabel ml-1" for="searchExcludeSubAgent">{{getLanguage["GL"]["ODA"]}}</label>
                                    </div>
                                </div>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :disable-branch-nodes="false"
                                                  :limitText="count => `+${count}`"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  v-model="arr_FV['AGI']"
                                                  :placeholder="this.utilGetDDLanguage('PM.AGI')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGAGI']"
                                            openDirection="below"
                                            :disabled="disableSubDD || searchExcludeSubAgent"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"                                            
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultMemberUserId"
                                            :auto-load-root-options="convertToBool(arr_FV['MB'] > 0 && strUsername)"
                                            :options="ddMemberList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="arr_FV['MB']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV.DR"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV.DR.startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV.DR.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV.DR"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV.DR.endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV.DR.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['RS']}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_memberpromotionstatus"
                                            :placeholder="this.utilGetDDLanguage('PM.RS')"
                                            v-model="arr_FV['RS']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MTA']['PMT']}} :</span>
                                <CInput size="sm" :value="arr_FV['PC']" @change="v => arr_FV['PC'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["OP"]}} :</span>
                                <CInput size="sm" :value="arr_FV['OP']" @change="v => arr_FV['OP'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["IP"]}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" checked @click="IPAddress()" v-model="searchExactIP" id="searchExactIP" />
                                        <label class="searchLabel ml-1" for="searchExactIP">{{getLanguage["HELP"]["IPS"]}}</label>
                                    </div>
                                </div>
                                <CInput size="sm" :value="arr_FV['AIP']" @change="v => arr_FV['AIP'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['SA']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_memberpromotionsystemapproved"
                                            :placeholder="this.utilGetDDLanguage('PM.SA')"
                                            v-model="arr_FV['ISA']"
                                            :max-height="200" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["C"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('PM.C')"
                                            v-model="arr_FV['CI']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['PM']}} / {{this.getLanguage['PM']['CCP']}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_commissiontype"
                                            :placeholder="this.utilGetDDLanguage('PM.PM')"
                                            v-model="arr_FV['CT']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["RU"]}} :</span>
                                <treeselect :key="dd_referralMemberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadReferralMemberOptions"
                                            :options="ddReferralMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchReferralUserId > 0 && searchReferralUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.RU')"
                                            @input="selectReferralMemberOptions"
                                            @deselect="deSelectReferralMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchReferralUserId" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="searchVDP" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['MTI']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_mt"
                                            :placeholder="this.utilGetDDLanguage('MEM.MTI')"
                                            v-model="searchMT" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RSN']}} :</span>
                                <CInput size="sm"
                                        :value="searchRegisterSourceName"
                                        @change="v => searchRegisterSourceName = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["FSGP"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="ddProviderListfs"
                                            :placeholder="this.utilGetDDLanguage('PM.FSGP')"
                                            v-model="arr_FV['FSGP']"
                                            :disabled="!bool_providerloaded"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />

                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency"
                                            @input="updateCC()" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="100%">{{this.getLanguage['MTA']['PRS']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_Psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-if=" arry_Psl.length != 0" @click="bool_showSummary = !bool_showSummary" class='kema-eft'>
                            <td style="width:5%"></td>
                            <td style="width:10%"></td>
                            <td style="width:10%"></td>
                            <td style="width:14%"></td>
                            <td style="width:10% "></td>
                            <td style="width:10%"></td>
                            <td style="width:25%"></td>
                            <td style="width:25%">{{this.getLanguage['MTA']['GT']}}</td>
                            <td style="width:16%" :style="renderActivityStyle(1)" :class="decimal_gt >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(decimal_gt, 2, GtcurrencySyntax) }}</td>
                        </tr>
                        </tbody>
                        <thead v-if="bool_showSummary">
                            <tr>
                                <th style="width:5%">{{this.getLanguage['MTA']['C']}}</th>
                                <th style="width:10% " class="tableCtnRight">{{this.getLanguage['MTA']['TMC']}}</th>
                                <th style="width:10%" class="tableCtnRight">{{this.getLanguage['MTA']['TPC']}}</th>
                                <th style="width:14%" class="tableCtnRight">{{this.getLanguage['MTA']['TFA']}}</th>
                                <th style="width:10% " class="tableCtnRight">{{ this.getLanguage["DLSP"]["NOS"] }}</th>
                                <th style="width:10%" class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"] }}</th>
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['PM']['PMTWL']}}</th>
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['MTA']['TPA']}}</th>
                                <th style="width:16%" class="tableCtnRight">{{this.getLanguage['MTA']['GT']}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="bool_showSummary">
                        <td colspan="100%" v-if=" arry_Psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arry_Psl">
                            <tr v-if="data.PC=='' && data.CT == 0" :style="{'background':ToggleCurrencyList.includes(data.IC)?'lightsalmon':''} ">
                                <td>{{ data.IC }} </td>
                                <td class="tableCtnRight">{{ formatNumber(data.TMC, 0) }}</td>
                                <td class="tableCtnRight">{{ formatNumber(data.TPC, 0) }}</td>
                                <td class="tableCtnRight">{{ formatNumber(data.TFA + data.TUWLA, 2, data.CS) }}</td>
                                <td class='tableCtnRight'>
                                    <span v-if="data.FS > 0" class="grid-line">
                                        {{ formatNumber(data.FS, 0) }}
                                    </span>
                                    <span v-else class="grid-line">-</span>
                                </td>
                                <td class='tableCtnRight'>
                                    <!--Spin Winning-->
                                    <span v-if="data.FSWA > 0" class="grid-line tableCtnRight">{{formatNumber(data.FSWA, 2,data.CS)}}</span>
                                    <span v-else class="grid-line tableCtnRight">-</span>
                                </td>
                                <td :style="renderActivityStyle(1)" :class="data.PTWL >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(data.PTWL, 2, data.CS) }}</td>
                                <td :style="[renderActivityStyle(3),{'cursor': 'pointer'},{'text-decoration': 'underline'}] " class="tableCtnRight" @click="toggleDisplay(data.IC)">{{ formatNumber(data.TPA, 2, data.CS) }}</td>
                                <td :style="renderActivityStyle(1)" :class="data.GTC >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(data.GTC, 2, data.CS) }}</td>
                            </tr>
                            <tr v-else-if="ToggleCurrencyList.includes(data.IC)">
                                <td colspan="8" :style="[{'position': 'relative'},renderActivityStyle(3)]">
                                    <span style="float: right">{{ formatNumber(data.TPA, 2, data.CS) }}</span>
                                    <span style="color: #1b1b1b; font-weight: 600; position: absolute; right: 180px">{{renderPromotionCode(data.PC, data.CT)}} :</span>
                                </td>
                                <td></td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <strong>{{getLanguage['PM']['PML']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['RS']}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GN' && !hideBrand">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['BN']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color:#ff8c00;font-weight:700">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color:red;font-weight:900">{{getLanguage['MEM']['SU']}}</span>
                                    </template>
                                    <template v-else-if="header == 'PC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['PMT']}}
                                        <i @click="setSortTable('PC')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['PA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['FBA']}}
                                        <i @click="setSortTable('RA')" :class="setSortLogo('RA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'WBB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['BB']}}
                                        <i @click="setSortTable('WBB')" :class="setSortLogo('WBB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ATA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['TO']}}
                                        <i @click="setSortTable('ATA')" :class="setSortLogo('ATA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'FS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['NOS']}}
                                        <i @click="setSortTable('FS')" :class="setSortLogo('FS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'FSWA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['SW']}}
                                        <i @click="setSortTable('FSWA')" :class="setSortLogo('FSWA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['PMWL']}}
                                        <i @click="setSortTable('PWL')" :class="setSortLogo('PWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['CT']}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['OP']}}
                                        <i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ATS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['APPTS']}}
                                        <i @click="setSortTable('ATS')" :class="setSortLogo('ATS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CLOTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['CPLTIME']}}
                                        <i @click="setSortTable('CLOTS')" :class="setSortLogo('CLOTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PTTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['PTTS']}}
                                        <i @click="setSortTable('PTTS')" :class="setSortLogo('PTTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['IP']}}
                                        <i @click="setSortTable('AIP')" :class="setSortLogo('AIP')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue' style="min-height: 100px;">
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['RS']}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GN' && !hideBrand">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['BN']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color:#ff8c00;font-weight:700">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color:red;font-weight:900">{{getLanguage['MEM']['SU']}}</span>
                                    </template>
                                    <template v-else-if="header == 'PC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['PMT']}}
                                        <i @click="setSortTable('PC')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['PA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['FBA']}}
                                        <i @click="setSortTable('RA')" :class="setSortLogo('RA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'WBB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['BB']}}
                                        <i @click="setSortTable('WBB')" :class="setSortLogo('WBB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ATA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['TO']}}
                                        <i @click="setSortTable('ATA')" :class="setSortLogo('ATA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'FS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['NOS']}}
                                        <i @click="setSortTable('FS')" :class="setSortLogo('FS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'FSWA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['DLSP']['SW']}}
                                        <i @click="setSortTable('FSWA')" :class="setSortLogo('FSWA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PWL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['PMWL']}}
                                        <i @click="setSortTable('PWL')" :class="setSortLogo('PWL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['CT']}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['OP']}}
                                        <i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ATS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['APPTS']}}
                                        <i @click="setSortTable('ATS')" :class="setSortLogo('ATS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CLOTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['CPLTIME']}}
                                        <i @click="setSortTable('CLOTS')" :class="setSortLogo('CLOTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PTTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['PTTS']}}
                                        <i @click="setSortTable('PTTS')" :class="setSortLogo('PTTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['IP']}}
                                        <i @click="setSortTable('AIP')" :class="setSortLogo('AIP')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_PromotionReportList == null">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_PromotionReportList" :class="data.MS == 1? 'blacklist-row': ''">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'RS'">
                                    <span class="grid-line">{{ renderStatus(data.RS) }}</span>
                                    <span class="grid-line rejectReason" v-if="data.RS==3">{{ renderRejectReason(data.RR) }}</span>
                                </template>
                                <template v-else-if="header == 'U'">
                                    <span class="grid-line" v-if="((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AAGI,data.MI)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span class="grid-line" v-else-if="(isSENS == 1 && data.AAGI != curAGI)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'GN' && !hideBrand">
                                    <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                    <span class="saggroupname" v-if="data.SAGPC != ''">{{ data.SAGGN }} ({{ data.SAGPC }})</span>
                                </template>
                                <template v-else-if="header == 'TSID'">
                                    <span style="text-align:center;display:block">
                                        <span v-if="getUserInfo.AT!=4">
                                            <span v-if="data.TSI > 0 && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                            </span>
                                            <span v-else-if="data.TSI > 0 && (isSENS == 1 && data.AAGI != curAGI)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                            </span>
                                            <span class="grid-line" v-else>-</span>
                                        </span>
                                        <span v-else-if="getUserInfo.AT==4">
                                            <span v-if="data.SUBATSI > 0 && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.SUBATSI }})</span> / <span style="color:red">({{ data.SUBATM }})</span>
                                            </span>
                                            <span v-else-if="data.SUBATSI > 0 && (isSENS == 1 && data.AAGI != curAGI)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.SUBATSI }})</span> / <span style="color:red">({{ data.SUBATM }})</span>
                                            </span>
                                            <span class="grid-line" v-else>-</span>
                                        </span>
                                        <table class='p-4 mt-2' v-if="opened.includes(data.I)" style="width: 100%; background: #ebedef">
                                            <thead>
                                                <tr>
                                                    <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                    <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(row,index1) in arry_systemId[data.I]">
                                                    <tr style="text-align: left;">
                                                        <td :style="[row.MI>0?{'cursor':'pointer'}:{}]" @click="row.MI>0?toggleFingPrintId(row,index,index1):{}" :class="{opened: opened.includes(index+'_'+index1)}">{{ row.SI }} <span style="color:red" v-if="row.MI>0">({{row.MI}})</span></td>
                                                        <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    </tr>
                                                    <tr v-if="opened.includes(index+'_'+index1)" style="background: darkred">
                                                        <td colspan="2" style="padding:2px">
                                                            <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item,index) in arry_visitorMembers[index+'_'+index1]" style="text-align:left">
                                                                        <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                        <td>
                                                                            <router-link :to="MCMI_V ? { path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}} : ''" :target="MCMI_V ? '_blank' : null">{{ item.UB }}</router-link>
                                                                        </td>
                                                                        <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </span>
                                </template>
                                <template v-else-if="header == 'PC'">
                                    {{ renderPromotionCode(data.PC, data.CT) }}
                                </template>
                                <template v-else-if="header == 'BA'">
                                    <div :style="renderActivityStyle(3)">
                                        {{ formatNumber(((data.PG==22 || data.PG==24 || data.PG==32 || data.PG==34) && data.WTA>data.ATA)?'-':data.BA, 2, data.CS) }}
                                        <div class="custom_tooltip">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="tooltiptext2 promotion-amount-tooltip">
                                                <div class="total-promo"><span class="tooltip-label">{{ getLanguage["PM"]["TBA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.TBA, 2, data.CS) }}</span></div>
                                                <div v-if="data.DA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["DA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.DA, 2, data.CS) }}</span></div>
                                                <div v-if="data.BA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["PA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.BA, 2, data.CS) }}</span></div>
                                                <div v-if="data.FBA > 0"><span class="tooltip-label">{{ getLanguage["PM"]["CF"] }} :</span><span class="tooltip-val">{{ formatNumber(data.FBA, 2, data.CS) }}</span></div>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="header == 'RA'">
                                    {{ formatNumber(data.RA, 2, data.CS) }}
                                    <div class="custom_tooltip">
                                        <i class="fa fa-question-circle"></i>
                                        <span class="tooltiptext2 promotion-amount-tooltip">
                                            <div class="total-promo"><span class="tooltip-label">{{ getLanguage["PM"]["BABC"] }} :</span><span class="tooltip-val">{{ formatNumber(data.BABC, 2, data.CS) }}</span></div>
                                            <div><span class="tooltip-label">{{ getLanguage["PM"]["FBA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.RA, 2, data.CS) }}</span></div>
                                            <div><span class="tooltip-label">{{ getLanguage["PM"]["RTA"] }} :</span><span class="tooltip-val">{{ formatNumber(data.RTMA, 2, data.CS) }}</span></div>
                                        </span>
                                    </div>
                                </template>
                                <template v-else-if="header == 'WBB'">
                                    <div :style="renderActivityStyle(3)">
                                        <span class="grid-line">{{ getLanguage["PM"]["WBB"] }} : {{ formatNumber(data.WBB, 2, data.CS) }}</span>
                                        <span class="grid-line" v-if="data.BBB > 0">{{ getLanguage["PM"]["BBB"] }} : {{ formatNumber(data.BBB, 2, data.CS) }}</span>
                                    </div>
                                </template>
                                <template v-else-if="header == 'ATA'">
                                    <span v-if="data.CT == 0">
                                        {{ formatNumber(data.ATA, 2, data.CS) }} / {{ formatNumber(data.WTA, 2, data.CS) }}
                                    </span>
                                    <span v-else>-</span>
                                    <div v-if="data.FWTA > 0">{{ getLanguage["PM"]["CF"] }} : {{ formatNumber(data.FWTA, 2, data.CS) }}</div>
                                </template>
                                <template v-else-if="header == 'FS'">
                                    <span v-if="data.FS > 0" class="grid-line" @click="viewFSDetail(data)">
                                        {{ data.FS }}
                                        <div class="float-right ml-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span v-else class="grid-line">-</span>
                                </template>
                                <template v-else-if="header == 'FSWA'">
                                    <!--Spin Winning-->
                                    <span v-if="data.FSWA > 0" class="grid-line tableCtnRight">{{formatNumber(data.FSWA, 2,data.CS)}}</span>
                                    <span v-else class="grid-line tableCtnRight">-</span>
                                </template>
                                <template v-else-if="header == 'PWL'">
                                    <span :style="renderActivityStyle(1)" :class="data.PWL >= 0? 'positive-number': 'negative-number'">
                                        {{ formatNumber(data.PWL, 2, data.CS) }}
                                    </span>
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    {{ formatDate(data.CTS, "YYYY-MM-DDTHH:mm:ss","DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'AT'">
                                    <div v-if="data.AT=='sys||promoturnover' || data.AT=='sys||promo'">sys||approved</div>
                                    <div v-else>{{ data.AT }}</div>
                                </template>
                                <template v-else-if="header == 'ATS'">
                                    <span v-if="data.AB != 'NA'">{{ formatDate(data.ATS, "YYYY-MM-DDTHH:mm:ss","DD MMM YYYY HH:mm:ss") }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'CLOTS'">
                                    <span v-if="data.RS >= 4 && data.RS <= 9 "> {{ formatDate(data.CLOTS, "YYYY-MM-DDTHH:mm:ss","DD MMM YYYY HH:mm:ss") }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'PTTS'">
                                    {{ formatDateTime(data.ETS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'AIP'">
                                    <router-link :to="{ path:'/M/ML/SamePromotionIP', query:{ ip: data.AIP}}">{{ data.AIP }}</router-link>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import { constPromotionStatus, constRejectReasonP, constPromotionSystemApproved, constAccessType, loadingFullScreen } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import Vue from 'vue'
    //Vue.use(require('vue-shortkey'))
    import $ from 'jquery'
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },

        data() {
            return {
                bool_FSD: false, // free spin details
                bool_fingerPrintLoading: [], // fingerprint/lastSystemID
                bool_showSearchBar: true,
                opened: [],
                arry_visitorMembers: [],
                arry_systemId: [],
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true,
                ddCurrencyList: null,
                searchCurrency: null,
                bool_isSearchCC: false,
                arr_FV: {
                    "MB": null,
                    "DR": {
                        startDate: this.getTodayDate(),
                        endDate: this.getMonthEndDate()
                    },
                    "RS": ["2", "4", "5", "7", "8"],
                    "PC": "",
                    "TT": 3,
                    "AGI": null,
                    "OP": "",
                    "AIP": "",
                    "ISA": null,
                    "CI": null,
                    "CT": null,
                    "AIP_WC": null,
                    "RI": "",
                    "SAGAGI": null,
                    "FSGP":null
                },
                arr_PromotionReportList: [],
                dd_memberpromotionstatus: [],
                dd_commissiontype: [],
                dd_memberpromotionsystemapproved: [],
                dd_currency: [],
                dd_agentgroup: [],
                dd_subagentgroup: [],
                ddProviderListfs: [],
                ddDefaultSubBrand: null,
                searchRegisterSourceName:null,
                rtSubBrand: 0,
                ddMemberList: [],
                arry_Psl: [],
                constAccessType: constAccessType,
                MCMI_V: false,
                searchExactIP: true,                
                dd_referralMemberKey: 0,
                GtcurrencySyntax: 'USD',
                ddReferralMemberList: null,
                ddDefaultMemberList: null,
                ddDefaultMemberUserId: [],
                searchReferralUserId: null,
                searchReferralUsername: null,
                hideBrand: false,
                searchAgi: "",
                arry_vdp: [],
                searchVDP: null,
                searchMT: null,
                dd_mt: [], // member type
                disableSubDD: false,
                obj_trans: [],
                defaultReportHeaders: ['NO', 'RS', 'GN', 'U', 'TSID', 'PC', 'BA', 'RA', 'WBB', 'ATA', 'FS', 'FSWA', 'PWL', 'CTS', 'AT', 'ATS', 'CLOTS', 'PTTS', 'AIP'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                bool_providerloaded: false,
                int_TP_GBT: 1,
                int_Page_GBT: 1,
                int_RC_GBT: 50,
                int_IC_GBT: 1,
                gbtData: null,
                searchExcludeSubAgent: false,
                ToggleCurrencyList: [],
                strUsername: "",                               
                strAGI: "",
                rfrAGI: "",
                dd_memberKey: 0,
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),            
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getPromotionReportList();
            },
            ctrPageGBT(newPage,inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_Page_GBT = Math.max(1, Math.min(newPage, this.int_TP_GBT));
                }
                else {
                    this.int_Page_GBT = (newPage > this.int_TP_GBT) ? 1 : (newPage < 1) ? this.int_TP_GBT : newPage;
                }
                this.int_IC_GBT = this.int_Page_GBT;
                if (this.gbtData != null) {
                    this.viewFSDetail(this.gbtData);
                }
            },
            getVDP() {
                this.dd_commissiontype = [{
                    id: "0",
                    label: this.getLanguage["PM"]["PM"]
                },
                {
                    id: "1",
                    label: this.getLanguage["PM"]["GT"]
                },
                {
                    id: "2",
                    label: this.getLanguage["PM"]["GWL"]
                }];

                this.dd_memberpromotionstatus = [{ // key1 = CTNT
                    id: "1",
                    label: this.getLanguage['DB']['AC1']//pending
                },
                {
                    id: "2",
                    label: this.getLanguage['DB']['AC2'] //AP
                },
                {
                    id: "3",
                    label: this.getLanguage['DB']['AC3']//RJ
                },
                {
                    id: "4",
                    label: this.getLanguage['DB']['AC4'] // CP
                },
                {
                    id: "5",
                    label: this.getLanguage['DB']['AC5']//C
                },
                {
                    id: "6",
                    label: this.getLanguage['DB']['AC6']//CCL
                },
                {
                    id: "7",
                    label: this.getLanguage['DB']['AC7']//SRD
                },
                {
                    id: "8",
                    label: this.getLanguage['DB']['AC8']//EP
                },
                {
                    id: "9",
                    label: this.getLanguage['DB']['AC9'] // CF
                }
                ];
                this.dd_memberpromotionsystemapproved = [{
                    id: "1",
                    label: this.getLanguage['PM']['YES']
                },
                {
                    id: "0",
                    label: this.getLanguage['PM']['NO']
                }
                ];
                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;                
                if (this.arr_FV.DR) {
                    if (this.arr_FV.DR.startDate != "") {
                        var z = this.set90daysDateSearch(this.arr_FV.DR.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                if (this.searchCurrency != null) {
                    this.bool_isSearchCC = true;
                } else
                {
                    this.bool_isSearchCC = false;
                }
                this.getPromotionReportList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            CountItemGbt(value) {
                if (this.int_IC_GBT != 1) {
                    return value + ((this.int_IC_GBT - 1) * this.int_RC_GBT);
                } else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getPromotionReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;
                //this.dd_memberpromotionstatus = constPromotionStatus;
                //if (that.dd_memberpromotionstatus) {
                //    for (var i = 0; i < that.dd_memberpromotionstatus.length; i++) {
                //        that.dd_memberpromotionstatus[i].label = that.renderStatusName(that.dd_memberpromotionstatus[i].label);
                //    }

                //    that.dd_memberpromotionstatus = that.dd_memberpromotionstatus;
                //    /*console.log("A");*/
                //}
                //else {
                //    that.dd_memberpromotionstatus = null;
                //    /*console.log("B");*/
                //}
                
                

                
                //this.getDataApi(`/api/dd/cur/0`,
                //    function (d, s) {
                //        if (s) {
                //            that.dd_currency = d.dropdownlist;
                //        }
                //    });

                this.bool_providerloaded = false;
                this.getDataApi(`/api/dd/game/frbprovbycategory/0/0` ,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.bool_providerloaded = true;
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label);
                            }
                            that.ddProviderListfs = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                            //var cloneParentGroup = that.deepClone(d.dropdownlist);

                            ////// list filter only push in child group, do not include own group
                            //if (cloneParentGroup != null && cloneParentGroup.length > 0) {
                            //    that.dd_agentgroup = [];
                            //    for (var i = 0; i < cloneParentGroup.length; i++) {
                            //        for (var j = 0; j < cloneParentGroup[i].children.length; j++) {
                            //            that.dd_agentgroup.push(cloneParentGroup[i].children[j]);
                            //        }
                            //    }
                            //}
                        }
                    });
                this.getDataApi(`/api/dd/mtname`,
                    function (d, s) {
                        if (s) {
                            that.dd_mt = d.dropdownlist
                        }
                    });
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchAgi) {
                    agi = this.searchAgi;
                }
                // for selecting brand and filter currency (for SSA,SA,MA )
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
                // for agent level and filter currency (no brand selection, for agent and sub agent level)
                var current_agi = this.getUserInfo.AGI;
                if (this.getUserInfo.AT >= 3)
                {
                    this.getDataApi(`/api/dd/cur/` + current_agi,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
                }
                this.bool_providerloaded = false;
                this.getDataApi(`/api/dd/game/frbprovbycategory/` + agi + `/0` ,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.bool_providerloaded = true;
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label);
                            }
                            that.ddProviderListfs = d.dropdownlist;
                        }
                    });
            },
            AgentGroupChangefs(value) {
                this.disableSubDD = false;
                this.arr_FV["AGI_csv"] = null;
                this.arr_FV["SAGAGI"] = null;
                this.dd_mt = [];
                var temp = "";
                if (value != undefined) {
                    //var agi = 0;
                    if (value != "") {
                        //agi = value.split("-")[1];
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.searchAgi = temp;
                        this.arr_FV["AGI_csv"] = temp;
                        this.arr_FV["SAGAGI"] = null;
                        if (value.length > 1) {
                            this.disableSubDD = true;
                        }
                    } else {
                        this.searchAgi = 0;
                    }
                } else {
                    this.searchAgi = 0;
                    this.arr_FV['AGI_csv'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currency = null;
                this.getCurrencyList();

                var that = this;
                this.getDataApi(`/api/dd/mtname/` + temp,
                    function (d, s) {
                        if (s) {
                            that.dd_mt = d.dropdownlist
                        }
                    });
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var agi = 0;
                    if (value != "") {
                        agi = value;
                        this.arr_FV["SAGAGI"] = agi;
                    }
                }
                else {
                    this.arr_FV["SAGAGI"] = null;
                }
            },            
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = "";
                    if (this.arr_FV["SAGAGI"]) {
                        agi = this.arr_FV["SAGAGI"];
                    } else if (this.arr_FV["AGI_csv"]) {
                        agi = this.arr_FV["AGI_csv"];
                    }

                    this.strAGI = agi;

                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;                                
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.arr_FV["AGI_csv"]) {
                    parentAGI = this.arr_FV["AGI_csv"];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else if (this.getUserInfo.AT != 3) {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                    return;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.arr_FV['SAGAGI'] = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getPromotionReportList();
                    });
            },            
            loadDefaultMemberList(memberId) {
                var that = this;
                var searchQuery = "";

                if (that.strUsername != "") {
                    searchQuery = encodeURIComponent(that.strUsername);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${that.strAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                //that.dd_MemberList = that.deepClone(d.dropdownlist);
                                that.ddDefaultMemberUserId = [
                                    { id: memberId, label: that.strUsername }
                                ];
                                that.dd_memberKey++;
                                that.arr_FV.MB = memberId;
                            }
                            else {
                                that.ddDefaultMemberUserId = [];
                            }
                            that.getPromotionReportList();
                        });
                }
            },
            loadDefaultReferralList(referralId) {
                var that = this;
                var searchQuery = "";

                if (that.searchReferralUsername != "") {
                    searchQuery = encodeURIComponent(that.searchReferralUsername);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.rfrAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {                                
                                that.ddDefaultMemberList = [
                                    { id: referralId, label: that.searchReferralUsername }
                                ];
                                that.dd_referralMemberKey++;
                                that.searchReferralUserId = referralId;
                            }
                            else {
                                that.ddDefaultMemberList = [];
                            }
                            that.getPromotionReportList();
                        });
                }
            },
            getUsernameById(mId) {
                var that = this;
                if (mId != null) {
                    this.getDataApi(`/api/reports/getusername/${mId}`,
                        function (d, s) {
                            if (s) {
                                that.strUsername = d;
                                if (that.strUsername) {
                                    that.loadDefaultMemberList(mId);
                                }
                            }
                        });
                }
            },
            getUsernameByRId(rId) {
                var that = this;
                if (rId != null) {
                    this.getDataApi(`/api/reports/getusername/${rId}`,
                        function (d, s) {
                            if (s) {
                                that.searchReferralUsername = d;
                                if (that.searchReferralUsername) {
                                    that.loadDefaultReferralList(rId);
                                }
                            }
                        });
                }
            },            
            getPromotionReportList() {
                this.bool_fullLoading = true;
                this.ToggleCurrencyList = [];                
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    var encodedSearchPromotionCode = "";
                    if(this.arr_FV["PC"] != null){
                        encodedSearchPromotionCode = encodeURIComponent(this.arr_FV["PC"].replace(/\[/g, '[[').replace(/\]/g, ']]'));                        
                    }
             

                    path += (
                        "f.MI=" + (this.arr_FV["MB"] == null ? "" : this.arr_FV["MB"]) +
                        "&f.PC=" + (encodedSearchPromotionCode) +
                        //"&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]) +
                        "&f.OP=" + (this.arr_FV["OP"] == null ? "" : this.arr_FV["OP"]) +
                        "&f.ISA=" + (this.arr_FV["ISA"] == null ? "" : this.arr_FV["ISA"])
                    );

                    if (this.searchExactIP) {
                        if (this.arr_FV["AIP"]) {
                            path += "&f.AIP=" + this.arr_FV["AIP"];
                        }
                    } else {
                        if (this.arr_FV["AIP"]) {
                            path += "&f.AIP_WC=" + this.arr_FV["AIP"];
                        }
                    }
                 
                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.PTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.PTS_to=" + cts_to;
                    }

                    if (this.arr_FV["CI"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.CI.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.CI[x];
                        }
                        path += ("&f.CI_csv=" + temp_);
                    }                    

                    if (this.arr_FV["RS"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.RS.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.RS[x];
                        }
                        path += ("&f.RS_in=" + temp_);
                    }

                    if (this.arr_FV["CT"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.CT.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.CT[x];
                        }
                        path += ("&f.CT_csv=" + temp_);
                    }

                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.ATAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : "4-" + this.arr_FV["SAGAGI"])
                    }
                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                    }
                }

                if (this.searchCurrency) {
                    path += "&f.CICI=" + this.searchCurrency;
                } else if (localStorage.getItem('CCUSD') != "") {
                    path += "&f.CICI=" + localStorage.getItem('CCUSD');
                }

                if (this.searchReferralUserId != null) {
                    path += "&f.RI=" + this.searchReferralUserId;
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (this.searchMT) {
                    path += "&f.TN=" + this.searchMT;
                }
                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }
                if (!this.arr_FV["SAGAGI"] && this.searchExcludeSubAgent) {
                    path += "&f.SAGI=0";
                    path += "&f.EXSAG=" + this.searchExcludeSubAgent;
                }
                path+="&f.FSGPI_in=" + (this.arr_FV["FSGP"] == null ? "" : this.arr_FV["FSGP"]) 

                this.getDataApi(`/api/mpromo/pr?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_PromotionReportList = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
                this.getDataApi(`/api/mpromo/lr/total?${path}`,
                    function (data) {
                        that.setPromotionSummaryList(data);
                    });
            },
            setPromotionSummaryList(data) {
                if (!data) {
                    data = [];
                }

                this.arry_Psl = data;
                this.decimal_gt = 0;
                if (this.arry_Psl.length != 0) {
                    for (var i = 0; i < this.arry_Psl.length; i++) {
                        this.decimal_gt += this.arry_Psl[i].GT;
                    }
                }
                this.GtcurrencySyntax = 'USD';
                if (this.arry_Psl.length != 0 && (this.bool_isSearchCC || localStorage.getItem('CCUSD') != "")) {
                    this.GtcurrencySyntax = this.arry_Psl[0].CS;
                }
            },
            renderStatus(statusCode) {
                return this.getLanguage['PM']['AC' + statusCode];
            },

            renderRejectReason(rejectReason) {
                const found = constRejectReasonP.some(el => el.id === rejectReason);

                if (found) {
                    for (var d of constRejectReasonP) {
                        if (d.id == rejectReason) {
                            rejectReason = d.label;
                        }
                    }
                }

                return rejectReason;
            },
            renderPromotionCode(promotionCode, commissionType) {
                if (commissionType == 1) {
                    return this.getLanguage["PM"]["TOCM"];
                }
                else if (commissionType == 2) {
                    return this.getLanguage["PM"]["WLCM"];
                }
                return promotionCode;
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }
            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: this.getTodayDate(),
                    endDate: this.getMonthEndDate()
                };
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    var encodedSearchPromotionCode = "";
                    if(this.arr_FV["PC"] != null){                        
                        encodedSearchPromotionCode = encodeURIComponent(this.arr_FV["PC"].replace(/\[/g, '[[').replace(/\]/g, ']]'));
                    }

                    path += (
                        "f.MI=" + (this.arr_FV["MB"] == null ? "" : this.arr_FV["MB"]) +
                        "&f.PC=" + (encodedSearchPromotionCode) +
                        //"&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]) +
                        "&f.OP=" + (this.arr_FV["OP"] == null ? "" : this.arr_FV["OP"]) +
                        "&f.ISA=" + (this.arr_FV["ISA"] == null ? "" : this.arr_FV["ISA"])
                    );

                    if (this.searchExactIP) {
                        if (this.arr_FV["AIP"]) {
                            path += "&f.AIP=" + this.arr_FV["AIP"];
                        }
                    } else {
                        if (this.arr_FV["AIP"]) {
                            path += "&f.AIP_WC=" + this.arr_FV["AIP"];
                        }
                    }

                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.PTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.PTS_to=" + cts_to;
                    }

                    if (this.arr_FV["CI"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.CI.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.CI[x];
                        }
                        path += ("&f.CI_csv=" + temp_);
                    }

                    if (this.arr_FV["RS"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.RS.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.RS[x];
                        }
                        path += ("&f.RS_in=" + temp_);
                    }

                    if (this.arr_FV["CT"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.CT.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.CT[x];
                        }
                        path += ("&f.CT_csv=" + temp_);
                    }

                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.ATAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : "4-" + this.arr_FV["SAGAGI"])
                    }
                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                    }
                }
                if (this.searchCurrency) {
                    path += "&f.CICI=" + this.searchCurrency;
                } else if (localStorage.getItem('CCUSD') != "") {
                    path += "&f.CICI=" + localStorage.getItem('CCUSD');
                }

                if (this.searchReferralUserId != null) {
                    path += "&f.RI=" + this.searchReferralUserId;
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                 if (this.searchMT) {
                    path += "&f.TN=" + this.searchMT;
                 }
                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }
                if (!this.arr_FV["SAGAGI"] && this.searchExcludeSubAgent) {
                    path += "&f.SAGI=0";
                    path += "&f.EXSAG=" + this.searchExcludeSubAgent;
                }
                path+="&f.FSGPI_in=" + (this.arr_FV["FSGP"] == null ? "" : this.arr_FV["FSGP"]) 

                window.open('/api/mpromo/promotionexcel?' + path, '_blank');
            },
            toggleFingPrintId(data, aRow, bRow) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.UBI;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(aRow + '_' + bRow);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[aRow + '_' + bRow] = d.D.Items;
                                that.opened.push(aRow + '_' + bRow)
                            }
                        });
                }
            },
            loadReferralMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddReferralMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = "";
                    if (this.arr_FV["SAGAGI"]) {
                        agi = this.arr_FV["SAGAGI"];
                    } else if (this.arr_FV["AGI_csv"]) {
                        agi = this.arr_FV["AGI_csv"];
                    }

                    this.rfrAGI = agi;

                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.rfrAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddReferralMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddReferralMemberList = [];
                            }

                            callback(null, that.ddReferralMemberList);
                        });
                }
            },
            selectReferralMemberOptions(node, instanceId) {
                // this.searchAgi = node.agi;
            },
            deSelectReferralMemberOptions(node, instanceId) {
                this.searchReferralUserId = null;
                this.searchReferralUsername = null;
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.MI;

                const index = that.opened.indexOf(data.I);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[data.I] = d.D.Items;
                                that.opened.push(data.I)
                            }
                        });
                }
                this.resizeTableHead()
            },
            IPAddress() {
                if (this.searchExactIP) {
                    this.searchExactIP = false;
                } else {
                    this.searchExactIP = true;
                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            viewFSDetail(dlsData) {
                this.gbtData = dlsData;
                this.obj_trans = [];
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page_GBT, this.int_RC_GBT, "CTS", true);

                if (path) {
                    path += "&";
                }

                path += ("f.D=" + dlsData.BC +
                    "&f.mi=" + dlsData.MI +
                    "&f.GPI=" + dlsData.FSGPI);

                if (this.searchCurrency) {
                    path += "&f.CICI=" + this.searchCurrency;
                } else if (localStorage.getItem('CCUSD') != "") {
                    path += "&f.CICI=" + localStorage.getItem('CCUSD');
                }

                this.getDataApi(`/api/dlspromo/lr/trans?${path}`,
                    function (data) {
                        that.int_TP_GBT = Math.max(data.D.TotalPages, 1);
                        that.obj_trans = data.D.Items;
                        that.bool_FSD = true;
                        that.bool_fullLoading = false;
                    });
            },
            closeFSD() {
                this.bool_FSD = !this.bool_FSD;
                this.gbtData = null;
                this.int_IC_GBT = 1;
                this.int_Page_GBT = 1;
                this.int_TP_GBT = 1;
            },
            renderGameName(providerName, gameName) {
                if (providerName in this.getLanguage && gameName in this.getLanguage[providerName])
                    return this.getLanguage[providerName][gameName];

                return gameName;
            },
            renderClassName(header, data) {
                if (header == 'U') {
                    return "kema-eft";
                } else if (header == 'BA' || header == 'RA' || header == 'WBB' || header == 'ATA' || header == 'PWL') {
                    return "tableCtnRight";
                } else if (header == 'FS') {
                    return "kema-eft tableCtnRight";
                }
            },
            resetColumn(headerName) {
                var that = this;
                if (that.hideBrand) {
                    that.removeDefaultColumn('GN')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            toggleDisplay(key) {
                const index = this.ToggleCurrencyList.indexOf(key);
                if (index > -1) {
                    this.ToggleCurrencyList.splice(index, 1)
                } else {
                    this.ToggleCurrencyList.push(key)
                }
            },
            loadCurrencyOptions() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            if (that.ddCurrencyList.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                        if (that.ddCurrencyList[i].id == localStorage.getItem('CCUSD')) {
                                            that.searchCurrency = that.ddCurrencyList[i].id;
                                            that.str_showDetails = (that.str_showDetails ? that.str_showDetails : that.ddCurrencyList[i].label);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                        }

                    });
            },
            updateCC() {
                if (this.searchCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.searchCurrency);
                }
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS4';
            this.$parent.showActiveMenu = 'R.PR';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;                        
            this.loadCurrencyOptions();

            //Event Type - Promotion Free Spin
            if (this.$route.query.et == 4) {
                this.arr_FV.RS.push("6","9");
            }
            else if (this.$route.query.et == 5) {
                //this.arr_FV.RS = [];
                this.arr_FV.RS.push("6");
            }

            //Promotion by Sub-Agent
            if (this.$route.query.pc == this.getLanguage["PM"]["TOCM"]) {
                this.arr_FV.CT = [];
                this.arr_FV.CT.push("1");
            }
            else if (this.$route.query.pc == this.getLanguage["PM"]["WLCM"]) {
                this.arr_FV.CT = [];
                this.arr_FV.CT.push("2");
            }
            else {
                this.arr_FV.PC = this.$route.query.pc;                
            }

            if (this.$route.query.rs) {
                this.arr_FV.RS = [];
                this.arr_FV.RS = this.$route.query.rs;
            }

            if (this.$route.query.mi) {               
                this.getUsernameById(this.$route.query.mi);                
            }
            if (this.$route.query.ri) {                
                this.getUsernameByRId(this.$route.query.ri);
            }

            this.arr_FV.AGI = this.$route.query.agi;            

            if (this.$route.query.ci) {
                this.arr_FV.CI = [];
                this.arr_FV.CI.push(this.$route.query.ci);
            }
            if (this.$route.query.pf) {
                this.arr_FV.DR.startDate = this.$route.query.pf;
            }
            if (this.$route.query.pt) {
                this.arr_FV.DR.endDate = this.$route.query.pt;
            }

            if (this.$route.query.agi !== undefined && this.$route.query.agi !== null) {
                this.getDropdownList(true);
                var split = this.$route.query.agi.split("-");
                if (split.length == 2) {
                    this.arr_FV.AGI_csv = split[1];
                }
                else {
                    this.arr_FV.AGI_csv = split[0];
                }
                this.arr_FV.AGI = ["3-" + this.arr_FV.AGI_csv];                
                this.AgentGroupChangefs(this.arr_FV.AGI);

                if (this.$route.query.sagi !== undefined && this.$route.query.sagi !== null && this.$route.query.sagi != 0) {
                    this.arr_FV.SAGAGI = this.$route.query.sagi;
                    this.loadDefaultSubBrand(this.arr_FV.SAGAGI);
                }                
            }
            else {
                this.getDropdownList(false);
                this.getPromotionReportList();
            }
            this.getVDP();            
            this.getCurrencyList();
            if (this.getUserInfo.AT == 4)
                this.loadDefaultSubBrand(0);
            if (this.$route.path != this.$route.fullPath)
                this.getPromotionReportList();

            this.MCMI_V = this.checkModuleAccess('MCMI', 'M', constAccessType.view);
        },
        watch: {
            getLanguage() {
                this.getPromotionReportList();
                this.getVDP();
                //this.getDropdownList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/PromotionReport`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                if (that.hideBrand) {
                                    that.removeDefaultColumn('GN')
                                    that.removeColumn('GN')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/PromotionReport/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/PromotionReport.vue